import { render, staticRenderFns } from "./exams.vue?vue&type=template&id=301d85f0&scoped=true&"
import script from "./exams.vue?vue&type=script&lang=js&"
export * from "./exams.vue?vue&type=script&lang=js&"
import style0 from "./exams.vue?vue&type=style&index=0&id=301d85f0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d85f0",
  null
  
)

export default component.exports